import { render, staticRenderFns } from "./messge-alert-pop.vue?vue&type=template&id=dc61342c&"
import script from "./messge-alert-pop.vue?vue&type=script&lang=js&"
export * from "./messge-alert-pop.vue?vue&type=script&lang=js&"
import style0 from "./messge-alert-pop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports